import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import userStore from '@/store/user';
import { HelpOther } from '@/common/helper';
import agentPageStore from '@/pages/agent-home/store'
import EE from '@/common/event';
import { Tooltip } from 'antd';
import Switch from '@/components/round-switch';

function NewSwitch({onClick, checked = false}) {
	const [activeTab, setActiveTab] = useState(checked);

  const getTooltipText = () => {
    let text = ''
    if(!userStore.isUser) {
      text = ''
    } else {
      const { chatLimit } = agentPageStore;
      if((chatLimit.daily_left || 0) + (chatLimit.invite_left || 0) <= 0) {
        text = '剩余使用次数已用尽！可邀请好友助力获得'
      } else {
        text = `剩余使用次数：${(chatLimit.daily_left || 0) + (chatLimit.invite_left || 0)}`
      }
    }

    return (
      <div className='text-left'>
        {text ? <div className='text-[rgba(255,255,255,0.6)]'>{text}</div> : null}
        <div><span className='font-bold-600'>自动分解并执行搜索任务：</span> 深度推理研究，执行复杂任务，智能交付结果</div>
      </div>
    )
  }

  const change = () => {
    if (!userStore.isUser && !activeTab) {
      HelpOther.toast("请先登录", "info");
      userStore.gotoLogin();
      return;
    }
    onClick?.(!activeTab ? 1 : 0)
    setActiveTab(!activeTab)
    EE.emit('chat_input_focus');
  }

	useEffect(() => {
		setActiveTab(checked)
	}, [checked])

  useEffect(() => {
    if(!userStore.isUser) return;
    agentPageStore.updateChatLimit();
  }, [userStore.isUser])

  return (
    <div 
      className='h-36px flex items-center gap-8px cursor-pointer pt-4px box-border'
      onClick={change}
    >
      <Switch 
        checked={activeTab}
      />
      <Tooltip
        className="flex items-center justify-center"
        title={getTooltipText()}
        arrow={false}
        align={{offset: [0, 10]}}
        placement="bottom"
      >
        <div className='text-black cursor-pointer'>
          深度研究  
        </div>
      </Tooltip>
    </div>
  );
}

export default observer(NewSwitch);
